import type { TaskEfficiencyReferenceType } from '@/tsClient/servers/noodleApi/ApiDefinition/taskEfficiency';
import type { TaskEfficiencyItem } from '@/tsClient/taskEfficiency';

/** Maps attachment reference types (hyphenated) to task efficiency reference types (underscored). */
const ATTACHMENT_TO_EFFICIENCY_TYPE: Record<string, TaskEfficiencyReferenceType> = {
  invoice: 'invoice',
  'custom-terms': 'custom_terms',
  'form-request': 'form_request',
  'document-request-user': 'document_request_user',
  'credit-report': 'credit_report',
  booking: 'booking',
  'e-signature-request': 'e_signature_request',
  'bank-account-integration': 'bank_account_integration',
};

/** Minimal shape of a workflow step needed for task efficiency item collection. */
export type WorkflowStepForEfficiency = {
  stepTaken: {
    message: {
      attachments: Array<{ referenceId: string; referenceType: string }>;
    } | null;
  } | null;
  nextSteps: WorkflowStepForEfficiency[];
};

/** Recursively collects task efficiency items from workflow step attachments. */
const collectTaskEfficiencyItems = (steps: WorkflowStepForEfficiency[], result: TaskEfficiencyItem[]): void => {
  for (const step of steps) {
    const attachments = step.stepTaken?.message?.attachments;
    if (attachments) {
      for (const attachment of attachments) {
        const efficiencyType = ATTACHMENT_TO_EFFICIENCY_TYPE[attachment.referenceType];
        if (efficiencyType) {
          result.push({ referenceType: efficiencyType, referenceId: attachment.referenceId });
        }
      }
    }
    if (step.nextSteps.length > 0) {
      collectTaskEfficiencyItems(step.nextSteps, result);
    }
  }
};

export default collectTaskEfficiencyItems;
